import { render, staticRenderFns } from "./Cotizacionv.vue?vue&type=template&id=097f1f5b&"
import script from "./Cotizacionv.vue?vue&type=script&lang=js&"
export * from "./Cotizacionv.vue?vue&type=script&lang=js&"
import style0 from "./Cotizacionv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports